import * as React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
import AddEvidenceModal from "./shared/AddEvidenceModal";
export const InvestigationsModal = React.forwardRef(
  ({ dashboard }, ref) => {
    const isAvailable = useActionCondition();
    if (!isAvailable) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(AddEvidenceModal, { ids: [dashboard.id], type: "dashboards", ref });
  }
);
const CoreDashboardActions = ({ modalRef }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  return /* @__PURE__ */ React.createElement(MenuItem, { icon: "extension", onClick: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  } }, t("core_actions.add_to_investigation"));
};
export default CoreDashboardActions;
